/*調整用変数*/
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', setFillHeight);
setFillHeight();

$(window).on('load resize', function(){
  var wW = document.body.clientWidth;
  var wWf = 0;
  if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)){
  	wWf = window.screen.width;
  }else{
    wWf = window.innerWidth;
  }
  $(":root").css('--scr_w', wWf - wW + 'px');
});


//ブレイクポイント
var wSp = 720;


//リンクスクロール
var hH;
$(function(){
	var speed = 400;
	
	$('a[href*="#"]'+':not(a[href*="#not_scr"]):not(a[class*="wishlist-btn"]):not(a[class*="addtoWishlist"])').click(function() {
		var url = $(this).attr("href");
      	var posi = url.lastIndexOf('#');
      	console.log(posi);
      	var href = url.substr(posi);      
		var target = $(href == "#" || href == "" ? 'html' : href);
		var wW	= $(window).width();
		
		if (wW <= wSp) {
			hH = 107;
		}else{
			hH = 134;
		}
  
		var position = target.offset().top - hH;
    
    if(target.prop('class') == 'fade') {
      position = position - 50;
    }
    
		
  $('html,body').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

	
	var wW	= $(window).width();
	var urlHash = location.hash;
	if(urlHash) {
		if (wW <= wSp) {
			hH = 107;
		}else{
			hH = 134;
		}
		$('body,html').stop().scrollTop(0);
		setTimeout(function(){
			var target = $(urlHash);
			var position = target.offset().top - hH;
      if(target.prop('class') == 'fade') {
        position = position - 50;
      }
			$('body,html').stop().animate({scrollTop:position}, speed);
		}, 100);
	}
});




//PSフッターメニュー展開
$(function(){
  $('#footer_info nav h2').click(function() {
    var wW	= $(window).width();
    if (wW <= wSp) {
      if(! $(this).next().is(':animated')){
        $(this).next().slideToggle('fast');
        $(this).toggleClass('finfo_nav_op');
      } 
    }
  });
});




// ギャラリースライダー（スマホ時のみ）
function spSlideList(slArea){
  var swiper; 
  $(window).on('load resize', function(){
      var w = $(window).width();
      if (w <= wSp) {
          if (swiper) {
              return;
          } else {
              swiper = new Swiper(slArea, {
                resizeReInit: true,
                cssMode: true,
                slidesPerView: 2.4
              });
          }
      } else {
          if (swiper) {
            swiper.destroy();
            swiper = undefined;
          } 
      } 
  });  
} 


//タブ切り替え
function tabChange(btn){
  btn.click(function() {
    jQuery(this).siblings().removeClass('tab_on');
    jQuery(this).addClass('tab_on');
  });
} 


// カスタムフィールド 商品セット
//スライドショー
function productSetGallery(slArea){
  if(slArea.find(".swiper-slide").length > 1){  

    var swiper = new Swiper(slArea, {
      loop: true,
      loopAdditionalSlides: 4,
      speed: 1500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  }
}
//価格チェックボックス
function productSetCalculation(area){
  var check = area + " input[type='checkbox']";
  var cAll = $(area + " input[name^='all']");
  var cSingle = area + " input[name^='set']";
  var total = $(area + " > p");
  
  cAll.change(function() {
    $(cSingle).prop('checked', this.checked);
  });

  $(cSingle).change(function() { 
    if ($(cSingle + ":checked").length == $(cSingle).length) {
      cAll.prop('checked', true);
    } else {
      cAll.prop('checked', false);
    }
  });
  
  $(check).change(function() {
    if ($(check + ":checked").length >= 1 ){
      total.css("opacity","1");
        
      total.children(".set_count").text($(cSingle + ":checked").length);
      
      let price = 0;
       $(cSingle + ":checked").each( function(){
         price += parseInt( $(this).val().replace(/,/, '') );
       });
      
      total.children(".set_total").text(price.toLocaleString());
  	}else{
      total.css("opacity","0");
	}
  });
}



//  2022/4/9 カート商品削除後にカートをリフレッシュ 
//function removeCartOption() {  
//  $('.cart-item--remove a').on('click', function() {       
//  	var del_area = $(this).parents('li').next('li[data-cartitem-id="42600513667238"]').remove();
//  });
  
//  r pageref = setInterval(function(){
//  location.reload();
//   1000);
//}



function productGalleryFirstImg(){ 
  $('.product-gallery').css('opacity','1');
  $('.gallery-navigation--scroller .product-gallery--media-thumbnail:first-child').trigger("click");
}



//サイドナビ展開
function sideNavAcc(){
  var btn = $('#side-category #side-shopping>li:not(.no-icon)>ul>li>button');
  btn.click(function() {
    $(this).next().slideToggle();
    $(this).toggleClass('btn_on');
  });
} 


// クッキーバナー
function cookieBnr(){
  var Bnr = $('#bnr_cookie_non_member');

  //Bnr.fadeIn();
  if(Cookies.get('cookieBnr') != 'Off'){
    Bnr.fadeIn();
  }
  
  Bnr.children('button.bnr-close').click(function(){  
    Cookies.set('cookieBnr', 'Off', {expires: 1});
   $(this).parent().fadeOut();
  });
}
function cookieBnrClause(){
  var Bnr = $('#bnr_cookie_non_member');
  
  Bnr.children('button').click(function(){
    $(this).parent().fadeOut();
  });
}


// バナー画像切り替え
function changeBnr(Bnr,afterImg){
   Bnr.click(function() {
    $(this).children('img').attr('src', afterImg);
    $(this).parent('#bnr_cookie_non_member').removeClass('chord_off');
  });  
}


// TOPページ Swiperスライド
function slBnr(slArea){
var sTag = '<div class=' + '"';
var cTag = '"' + '>';
var eTag = '</div>';
  
slArea.append(sTag + 'sw-pager' + cTag + eTag);
var slideLength = document.querySelectorAll('.swiper-wrapper .swiper-slide').length;	
	
if (slideLength > 1) {
var swiper = new Swiper(slArea, {
    loop: true,
    loopAdditionalSlides: 1,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.sw-pager',
      type: 'bullets',
      clickable: true
    }
  });
}
}


